import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'
import { MODIFY_ERROR_CODES } from '@/root/shared-types/api/reservation'

export const EDIT_TABS = {
  ROUTE: 'edit-reservation',
  TICKETS: 'travel-data',
  CUSTOMER: 'additional-services',
} as const

export type EditReservationTab = (typeof EDIT_TABS)[keyof typeof EDIT_TABS]

export const MODIFY_ERROR_MESSAGE_KEYS: Record<string, Key> = {
  [MODIFY_ERROR_CODES.FAILED_TO_ALLOCATE_PAX_INVENTORY]: 'editErrorNoPassengerSeats',
  [MODIFY_ERROR_CODES.FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY]: 'editErrorNoVehicleSpace',
  [MODIFY_ERROR_CODES.FAILED_TO_ALLOCATE_CAR_DECK_INVENTORY_BY_WEIGHT]: 'editErrorNoVehicleSpace',
  [MODIFY_ERROR_CODES.EXCLUDED_PRICE_CATEGORY]: 'editErrorExcludedPrice',
  [MODIFY_ERROR_CODES.SAIL_NOT_FOUND]: 'editErrorSailNotFound',
  [MODIFY_ERROR_CODES.DISCOUNT_ALREADY_USED_ON_SAIL]: 'discountAlreadyUsedOnSail',
  [MODIFY_ERROR_CODES.RESERVATION_REMOVED_ALL_ITEMS]: 'editErrorAllItemsRemoved',
  [MODIFY_ERROR_CODES.CURB_WEIGHT_VIOLATION]: 'editErrorWeightBelowCurb',
  [MODIFY_ERROR_CODES.INVALID_PERSONAL_IDENTIFICATION_NUMBER]: 'INVALID_PERSONAL_IDENTIFICATION_NUMBER',
}
